// Gardes de type partagées : une valeur reçue (corps de requête, message d'un client) est-elle une clé connue ?

/**
 * Garde « clé de ce catalogue » : seulement ses propres clés (`'toString'` ou `'__proto__'`, hérités, sont refusés —
 * contrairement à `value in record`).
 */
export const isKeyOf = <K extends string>(record: Readonly<Record<K, unknown>>) =>
  (value: unknown): value is K => typeof value === 'string' && Object.hasOwn(record, value);
